if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor () {
        super()

        this.form = this.querySelector('form')
        this.form.querySelector('[name=id]').disabled = false
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
        this.submitButton = this.querySelector('[type="submit"]')
        this.hideErrors = this.dataset.hideErrors === 'true'
        this.quickAddModal = this.closest('quick-add-modal')

        // Initialize variant selector
        this.initVariantSelector()
      }

      initVariantSelector () {
        this.variantSelect = this.querySelector('[data-product-card-variant-select]')
        this.hiddenInput = this.querySelector('input[name="id"]')
        this.buttonText = this.submitButton?.querySelector('span')

        if (this.variantSelect) {
          this.variantSelect.addEventListener('change', this.onVariantChange.bind(this))
        }
      }

      onVariantChange (event) {
        const selectedOption = event.target.options[event.target.selectedIndex]
        const variantId = selectedOption.value
        const isAvailable = selectedOption.dataset.available === 'true'

        // Update hidden variant ID input
        if (this.hiddenInput) {
          this.hiddenInput.value = variantId
        }

        // Update button state
        this.updateAddToCartButton(isAvailable)
      }

      updateAddToCartButton (isAvailable) {
        if (!this.submitButton || !this.buttonText) return

        if (isAvailable) {
          this.submitButton.removeAttribute('disabled')
          this.buttonText.textContent = this.submitButton.dataset?.addToCartString || window.variantStrings?.addToCart || 'Add to cart'
        } else {
          this.submitButton.setAttribute('disabled', 'disabled')
          this.buttonText.textContent = window.variantStrings?.soldOut || 'Sold out'
        }
      }

      async onSubmitHandler (evt) {
        evt.preventDefault()
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return

        this.handleErrorMessage()

        this.submitButton.setAttribute('aria-disabled', true)
        this.submitButton.classList.add('loading')

        const added = await this.addToCart()

        this.submitButton.classList.remove('loading')
        this.submitButton.removeAttribute('aria-disabled')

        this.handleErrorMessage(added?.errors)

        if (this.isOnCartPage()) {
          if (window.drawers) {
            window.drawers.activeDrawerKey = null
          }
        } else if (this.quickAddModal) {
          document.body.addEventListener(
            'modalClosed',
            () => {
              setTimeout(() => {
                window.drawers.activeDrawerKey = 'cart'
              })
            },
            { once: true },
          )

          this.quickAddModal.hide(true)
        }
      }

      handleErrorMessage (errorMessage = false) {
        if (this.hideErrors) return

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper')
        if (!this.errorMessageWrapper) return
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message',
          )

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage)

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage
        }
      }

      async addToCart () {
        try {
          // If we're on cart page, use cart sections and prevent push cart events
          if (this.isOnCartPage()) {
            return await window.BAO.Cart.addItemFromForm(this.form, {
              sections: window.BAO.sectionRenderer.cartSections.map(s => s.section),
              preventPushCartEvents: true
            })
          }

          return await window.BAO.Cart.addItemFromForm(this.form)
        } catch (error) {
          console.error('Error adding to cart:', error)
          return { errors: error.message || 'An error occurred while adding to cart' }
        }
      }

      isOnCartPage () {
        return document.querySelector('cart-items') != null
      }
    },
  )
}
